export default __webpack_public_path__ + "static/media/PresidenteOpen.45240fb9.jpg";